// 简化版：按 route.meta 优先；缺失时用路径+缓存辅助推断
import router from '@/router'
import { getCache, setCache, clearCache } from '@/utils/cache'

const TOKEN_PREFIX = 'token'

function resolveScope(route) {
  const r = route || router.currentRoute
  const meta = r?.meta || {}
  let system = meta.system
  let terminal = meta.terminal

  if (!system || !terminal) {
    const path = r?.path || ''
    console.log('Route Path:', path);
    // 按路径大类推断系统
    if (!system) {
      system =
        path.startsWith('/logisticsTender') ? 'logistics' :
        path.startsWith('/auctionItem') ? 'forestry' :
        'procurement'
    }
    // 终端缺失时，结合 user_type 推断（3/4=投标端）
    if (!terminal) {
      const userType = getCache('user_type')
      terminal = (userType === 3 || userType === 4) ? 'bid' : 'tender'
    }
  }
  console.log('Resolved Scope:', { system, terminal });
  return { system, terminal }
}

function tokenKey(scope) {
  const { system = 'default', terminal = 'default' } = scope || {}
  return `${TOKEN_PREFIX}:${system}:${terminal}`
}

export function getCurrentScope(route) {
  return resolveScope(route)
}

export function getScopedToken(route) {
  const scope = resolveScope(route)
  const key = tokenKey(scope)
  return getCache(key) || null
}

export function setScopedToken(token, route) {
  const scope = resolveScope(route)
  const key = tokenKey(scope)
  setCache(key, token)
}

export function removeScopedToken(route) {
  const scope = resolveScope(route)
  const key = tokenKey(scope)
  clearCache(key)
}